<div class="start-page-header">
  <img class="hvb-logo" (click)="navigateToStart()" alt="HVB Logo"
       src="../../../../assets/img/start-page/HVB_Logo.svg">
  <div class="button-wrapper justify-content-end w-75">
    <button class="btn about-button" (click)="navigateToAbout()">
      {{'startPage.header.about'|translate}}
    </button>
    <button class="btn event-button" (click)="navigateToEvents()">
      {{'startPage.header.events'|translate}}
    </button>
    <button class="btn download-button" (click)="navigateToDownloads()">
      {{'startPage.header.downloads'|translate}}
    </button>
    <button class="btn contact-button" (click)="navigateToContact()">
      {{'startPage.header.contact'|translate}}
    </button>
    <button id="loginBtn" class="btn login-button"
            (click)="this.login()">
      {{'startPage.header.login' | translate}}
    </button>
  </div>
</div>
